import { getRequest, postRequest, getcontractIdNumber } from './api'

export async function list(size, index, searchTerm, orderBy) {
  if (!searchTerm.includes('ContractID'))
    searchTerm = `${searchTerm}, ContractID:${getcontractIdNumber()},`  
  return getRequest(`invoice2/get-list/${size || 10}/${index || 0}/${searchTerm || '%20'}/${orderBy || '%20'}`)
}

export async function find(id) {
  return getRequest(`invoice2/edit/${id}`)
}

export async function save(values) {
  return postRequest(`invoice2/save`, values)
}

export function remove(values) {
  return postRequest(`invoice2/delete`, values)
}

export async function find2(id){
  return getRequest(`invoice2/edit-by-workorder/${id}`)
}

export async function createInvoice() {
  const id = getcontractIdNumber()
  return getRequest(`invoice2/create-invoice/${id}`)
}